import { ComponentAPI } from '@philips-emr/tws-core';

class SpotlightAPI extends ComponentAPI {
  canEditEstablishment(): boolean {
    return this.state.canEditEstablishment;
  }

  setCanEditEstablishment(canEditEstablishment: boolean): void {
    this.setState({ canEditEstablishment });
  }

  getCanEditProfile(): boolean {
    return this.state.canEditProfile;
  }

  setCanEditProfile(canEditProfile: boolean): void {
    this.setState({ canEditProfile });
  }

  getCanEditSector(): boolean {
    return this.state.canEditSector;
  }

  setCanEditSector(canEditSector: boolean): void {
    this.setState({ canEditSector });
  }

  getEditInformationExpression(): string {
    return this.state.editInformationExpression;
  }

  setEditInformationExpression(editInformationExpression: string): void {
    this.setState({ editInformationExpression });
  }

  getEstablishmentExpression(): string {
    return this.state.establishmentExpression;
  }

  setEstablishmentExpression(establishmentExpression: string): void {
    this.setState({ establishmentExpression });
  }

  getLogoutExpression(): string {
    return this.state.logoutExpression;
  }

  setLogoutExpression(logoutExpression: string): void {
    this.setState({ logoutExpression });
  }

  getProfileExpression(): string {
    return this.state.profileExpression;
  }

  setProfileExpression(profileExpression: string): void {
    this.setState({ profileExpression });
  }

  getSearchExpression(): string {
    return this.state.searchExpression;
  }

  setSearchExpression(searchExpression: string): void {
    this.setState({ searchExpression });
  }

  getSectorExpression(): string {
    return this.state.sectorExpression;
  }

  setSectorExpression(sectorExpression: string): void {
    this.setState({ sectorExpression });
  }
}

export default SpotlightAPI;
